import React, { useEffect, useRef, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const AuthCallback = () => {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  const processAuth = useCallback(async () => {
    try {
      // Extract session_id from URL fragment
      const hash = window.location.hash;
      const params = new URLSearchParams(hash.substring(1));
      const sessionId = params.get('session_id');

      if (!sessionId) {
        console.error('No session_id found in URL');
        navigate('/admin');
        return;
      }

      // Exchange session_id for session_token
      const response = await axios.post(
        `${BACKEND_URL}/api/auth/session?session_id=${sessionId}`,
        {},
        { withCredentials: true }
      );

      const user = response.data;

      // Navigate to admin bookings with user data
      navigate('/admin/bookings', {
        replace: true,
        state: { user }
      });

    } catch (error) {
      console.error('Auth callback error:', error);

      // Check if it's an access denied error
      if (error.response?.status === 403) {
        alert('Access Denied ! ❌ Contact Owner for Access');
      } else {
        alert('Authentication failed. Please try again.');
      }

      navigate('/admin', { replace: true });
    }
  }, [navigate]);

  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    processAuth();
  }, [processAuth]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-gray-800 to-black flex items-center justify-center">
      <div className="text-center">
        <div className="inline-block animate-spin rounded-full h-16 w-16 border-t-4 border-b-4 border-yellow-400 mb-4"></div>
        <p className="text-white text-xl">Authenticating...</p>
      </div>
    </div>
  );
};
